module.exports = __webpack_public_path__ + "img/QueXian04.c3903822.png";